// extracted by mini-css-extract-plugin
export default {"container":"user-entrance_container__w47eS"};